import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'preview-btn',
	template: require('./preview-btn.html'),
	styles: [require('./preview-btn.scss')]
})
export class PreviewBtnComponent {
	@Input() text = 'Preview';
	@Input() previewLink: string;

	btnText: string;

	constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/buttons/preview-btn/preview-btn.ts